module.exports = __webpack_public_path__ + "img/singup3.1c6cdc98.jpg";